/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import config from "../config/presentationList.config.json";
import axios from "axios";

import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { GET_PRESENTATION_LIST } from "../graphql";
import { VApplication } from "../../../application";
import moment from "moment-timezone";

const is = require("is_js");
const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface IPresentationListMethods extends IPluginMethodMap {
  getPresentationListProps(args: any): Promise<any>;
}

export class PresentationListService implements IAgentPlugin {
  readonly methods: IPresentationListMethods;

  constructor() {
    this.methods = {
      getPresentationListProps: this.getPresentationListProps.bind(this),
    };
  }

  async getPresentationListProps(args: any) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    console.log("Args ", args);
    let filter_apply = {};
    if (args?.filter && is.existy(args?.filter)) {
      filter_apply = this.convertCriteria(args?.filter);
    }

    try {
      if (client) {
        const res = await client.query({
          query: GET_PRESENTATION_LIST,
          variables: {
            options: {
              limit: args?.size ?? 10,
              skip: args?.offset ?? 0,
              sort: {
                order: "asc",
                field: "status",
              },
            },
            filter: filter_apply,
          },
          fetchPolicy: "network-only",
        });
        if (res?.data) {
          let _totalPages = res?.data?.getPresentations.count
            ? parseInt(res?.data?.getPresentations.count) / 10
            : 1;

          let _currentPage =
            res?.data?.getPresentations.currentPage /
              res?.data?.getPresentations.pageSize +
            1;
          let _rowData = this.formatPresentationTabl(
            res?.data?.getPresentations.content,
            res?.data?.getPresentations.content
          );
          return {
            ...config,
            ultUsers: _rowData,
            isEmpty: res?.data?.getPresentations.count <= 0,
            // studentGroup: holderGroups,
            activePage: _currentPage,
            pageSize: res?.data?.getPresentations.pageSize,
            totalCount: res?.data?.getPresentations.count,
            totalPages: _totalPages,
          };
        }
      }
    } catch (err: any) {
      let _display_message =
        err?.graphQLErrors &&
        Array.isArray(err?.graphQLErrors) &&
        err?.graphQLErrors.find((item: any) => item.extensions);
      if (_display_message?.extensions?.display_message) {
        throw Error(_display_message?.extensions?.display_message);
      }

      throw err;
    }
  }

  private convertCriteria(criteria: any) {
    const result: any = {};
    for (const key in criteria) {
      if (criteria[key] !== null) {
        result[key] = { eq: criteria[key] };
      }
    }
    return result;
  }

  private formatPresentationTabl(data: any, roles: any[]) {
    let _rowData: any =
      Array.isArray(data) &&
      data.map((item: any) => {
        return {
          year: item?.year,
          id: item?.id,
          createdAt: item?.createdAt,
          status: this.getFormattedStatus(item?.status),
          name: item?.name,
          country: item?.country,
        };
      });
    return _rowData;
  }

  private _getRole(roles: any[]) {
    let _res: any[] = [];
    roles &&
      Array.isArray(roles) &&
      roles.length > 0 &&
      roles.map((item: any, index: number) => {
        _res.push(item?.name);
      });
    return _res;
  }

  private formatCreatedDate(date: Date) {
    if (date) {
      return moment(date).format("LL");
    }
  }

  private getFormattedStatus(status: string) {
    switch (status) {
      case "active":
        return "Active";
      case "inActive":
        return "In Active";
      case "hidden":
        return "Hidden";
      default:
        return "-";
    }
  }
}
